import {createSelector} from 'reselect';
import {getFrom} from '@pluto/utils';
import {DeliveryManagerManifestState} from '../DeliveryManagerManifestTypes';

interface State {
    deliveryManagerManifest: DeliveryManagerManifestState;
}

const selectSelf = (state: State) => state;

export const selectDeliveryManagerManifest = createSelector(
    selectSelf,
    getFrom('deliveryManagerManifest')
);
